<template>
  <div class="new_vip">
    <div class="content">
      <Role></Role>
    </div>
    <Judge :show="showJudge" @gotoNext="gotoNext()"></Judge>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Role from "@/views/apply/employee/role"
import { selectStoreList } from "@/api/storeManage";
import Judge from "@/components/vip/judgeDialog";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      showJudge:false,
    }
  },
  mounted(){
    this.init();
  },
  methods:{
    init(){ //先判断有没有店铺 没有的话提示跳转创建店铺
      var data = {
        token: this.token,
        app_id: this.app_id
      }
      selectStoreList(data).then( res => {
        if(res.code == 400){
          this.showJudge = true;
        }else{
        }
      })
    },
    gotoNext(){ //没有创建店铺 下一步前往创建
      this.$router.push('/apply/newVip/13/shop/shopList')
    }
  },
  components: {
    Role,
    Judge
  }
}
</script>

<style lang="scss" scoped>
.new_vip{
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  .content{
    background: #fff;
    overflow: auto;
    height: 100%;
  }
}
</style>